// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class UIntValue implements flatbuffers.IUnpackableObject<UIntValueT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): UIntValue {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsUIntValue(bb: flatbuffers.ByteBuffer, obj?: UIntValue): UIntValue {
    return (obj || new UIntValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsUIntValue(bb: flatbuffers.ByteBuffer, obj?: UIntValue): UIntValue {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new UIntValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  static startUIntValue(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, value: number) {
    builder.addFieldInt32(0, value, 0);
  }

  static endUIntValue(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createUIntValue(builder: flatbuffers.Builder, value: number): flatbuffers.Offset {
    UIntValue.startUIntValue(builder);
    UIntValue.addValue(builder, value);
    return UIntValue.endUIntValue(builder);
  }

  unpack(): UIntValueT {
    return new UIntValueT(this.value());
  }

  unpackTo(_o: UIntValueT): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): UIntValueT {
    const t = new UIntValueT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class UIntValueT implements flatbuffers.IGeneratedObject {
  constructor(public value: number = 0) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return UIntValue.createUIntValue(builder, this.value);
  }

  clone(): UIntValueT {
    const obj = new UIntValueT();
    obj.value = this.value;
    return obj;
  }

  equals(other: UIntValueT): boolean {
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyUIntValue(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
  } finally {
    verifier.popDepth();
  }
}
